import { useQuery } from 'react-query';
import { getToken } from '../helpers';

const headers = { 'Content-type': 'application/json' };

const reactQueryApiClient =
  (baseUrl) =>
  async ({ queryKey }) => {
    // const path = typeof queryKey === 'string' ? queryKey : queryKey[0] + qs(queryKey[1]);
    const path = typeof queryKey === 'string' ? queryKey : queryKey[0];

    const config = getConfig();

    const response = await fetch(baseUrl + path, config);

    if (response.status === 401) {
      window.location.href = '/golfclub-admin/logout';
    }

    if (!response.ok) {
      // console.log('Error', response);
      throw new Error(await response.json());
    }

    try {
      const jsonResponse = await response.json();
      return jsonResponse;
    } catch {
      return Promise.resolve();
    }
  };

export default reactQueryApiClient;

const getConfig = (customConfig = {}) => {
  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const config = {
    method: 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers
    }
  };

  return config;
};

export const useCampaign = () => useQuery('admin-gc/campaigns');
export const useProducts = () => useQuery('admin-gc/products');
export const useSales = () => useQuery('admin-gc/sales');
export const useStockBalance = () => useQuery('admin-gc/sales/stock-balance');

const queryOptions = {
  staleTime: 1000 * 60 * 5
};

export const useStatisticVisit = () =>
  useQuery('admin-gc/statistics/golfclub/visit-information', queryOptions);
export const useStatisticMonth = () =>
  useQuery('admin-gc/statistics/golfclub/months', queryOptions);
export const useStatisticWeekday = () =>
  useQuery('admin-gc/statistics/golfclub/weekdays', queryOptions);
export const useStatisticSurvey = () =>
  useQuery('admin-gc/statistics/golfclub/survey', queryOptions);
